import ProjectsGalleryItem from './ProjectsGalleryItem';

export default ProjectsGalleryItem;
